// extracted by mini-css-extract-plugin
export default {"actions":"InvoiceModal_actions__tgoqE"};